import { Injectable, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { from, Observable} from 'rxjs';

import { map } from 'rxjs/operators';
import { SharepointService } from './sharepoint.service';


@Injectable({
  providedIn: 'root'
})
export class ExcelService { 

  constructor(private sharePointService:SharepointService ) { }

	public read(file$: Observable<any>, url: string, sheetNames: string[], subsite?: string, options?: {header?: any, range?: number, defVal?:any}[]){
		// startRow = startRow || 0;
		
		return file$
		.pipe(map((blob)=>{
			// console.log('blob',blob);
			let data = new Uint8Array(blob);
			var arr = new Array();
			for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
			var bstr = arr.join("");
			// console.time('xlsx-read');
			var workbook = XLSX.read(bstr, { type: "binary", sheetStubs: true });
			var sheet_name_list = workbook.SheetNames;
			let sheetObj = {};
			sheetNames.forEach((sheet,index)=> {
				// console.log('workbook ',workbook.Sheets[sheet]);
				let option = options[index] || {}
				sheetObj[sheet] = XLSX.utils.sheet_to_json(workbook.Sheets[sheet],option)
			})
			sheetObj['fileName']= url;
			// console.timeEnd('xlsx-read');
			return sheetObj;
		}));

	}

	exportTableToExcel(tableElementRef: ElementRef, fileName: string, sheetName?: string, replace?: string[])
	{
	  sheetName = sheetName || 'Sheet1';
	  const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(tableElementRef.nativeElement);
	if(replace){
		Object.keys(ws).forEach(key=>{
			replace.forEach(r=>{
				if(typeof ws[key].v === 'string' ) ws[key].v = ws[key].v.split(r).join("");
			})
		})
	}

	  const wb: XLSX.WorkBook = XLSX.utils.book_new();
	  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  
	  /* save to file */
	  XLSX.writeFile(wb, fileName);
  
	}



  
}
